import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { Params, RouterModule } from '@angular/router';
import { AkitaRemoteConfigQuery } from '@app/akita/api/remote-config/state/remote-config.query';
import { AkitaRouterQuery } from '@app/akita/router/state/router.query';
import { AkitaScreenQuery } from '@app/akita/screen/state/screen.query';
import { ScreenSizeInfoState } from '@app/akita/screen/state/screen.store';
import { StartingPriceModel } from '@app/shared/models/api/starting-price.model';
import { Observable } from 'rxjs';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@ngneat/transloco';

// Components
import { categoryItemImagesMockData } from './category-item-images.mock-data';

@Component({
  selector: 'app-category-item',
  templateUrl: './category-item.template.html',
  styleUrls: ['./category-item.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslocoModule, RouterModule],
})
export class CategoryItemComponent implements OnChanges {
  @Input() public product?: StartingPriceModel | null;

  public biggerThan$: Observable<ScreenSizeInfoState>;

  public sharedImages$ = this.akitaRemoteConfigQuery.selectSharedImageCategory();

  public mockData = categoryItemImagesMockData;

  public parsedCategory: string | null;

  public urlFragments: string | string[];
  public queryParameters: Params;
  public readMore: boolean;

  public readonly lessThan$: Observable<ScreenSizeInfoState>;

  constructor(
    private readonly akitaScreenQuery: AkitaScreenQuery,
    private readonly changeDetector: ChangeDetectorRef,
    private readonly akitaRouterQuery: AkitaRouterQuery,
    private readonly akitaRemoteConfigQuery: AkitaRemoteConfigQuery
  ) {
    this.biggerThan$ = this.akitaScreenQuery.selectBiggerThan();
    this.readMore = false;

    this.parsedCategory = this.capitalizeCategory(this.product?.category || '');

    this.queryParameters = {
      ...this.akitaRouterQuery.queryParamsToKeep,
    };
    this.urlFragments = '';
    this.lessThan$ = this.akitaScreenQuery.selectLessThan();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      this.parsedCategory = this.capitalizeCategory(this.product?.category || '');

      this.sharedImages$ = this.akitaRemoteConfigQuery.selectSharedImageCategory();

      this.urlFragments = this.getCategoryCollectionFragment(
        this.product?.category || ''
      );
      this.queryParameters = {
        ...this.akitaRouterQuery.queryParamsToKeep,
      };
      this.changeDetector.markForCheck();

      /* if (this.product?.upToDiscount) {
        this.discount = this.product?.upToDiscount * -1;
      } */
    }
  }

  public capitalizeCategory(str: string): string | null {
    // console.log()
    return str
      .charAt(0)
      .toUpperCase()
      .concat(str.slice(1).replace(/ /g, '_').toLowerCase());
  }

  public getSearchUrlFragment(): Array<string> | string {
    return this.akitaRouterQuery.getPhoneSearchFragment();
  }

  public getCategoryCollectionFragment(cat: string): Array<string> | string {
    const fragment = this.akitaRouterQuery.homeUrlFragment;
    fragment.push('c');
    fragment.push('category');
    fragment.push(cat.toLowerCase());
    return fragment;
  }
}
